export default __webpack_public_path__ + "static/media/icon-instagram.24920a6c.svg";